module.exports = __webpack_public_path__ + "img/team-06.fec1af21.jpg";